import { render, staticRenderFns } from "./ManoeuvreRatingView.vue?vue&type=template&id=bcba20de"
import script from "./ManoeuvreRatingView.vue?vue&type=script&lang=js"
export * from "./ManoeuvreRatingView.vue?vue&type=script&lang=js"
import style0 from "./ManoeuvreRatingView.vue?vue&type=style&index=0&id=bcba20de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports